import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AsyncImportJobDetailsFragment = { __typename?: 'AsyncImportJobDocument', asyncImportJobId: string, jobType: Types.AsyncImportJobType, status: Types.AsyncImportJobStatus, autoStartImport: boolean, totalRows: number, validatedRows: number, importedRows: number, failedRows: number, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, completedAt?: Types.TDateISO | null };

export type AsyncImportJobSummaryFragment = { __typename?: 'AsyncImportJobDocument', asyncImportJobId: string, jobType: Types.AsyncImportJobType, status: Types.AsyncImportJobStatus, autoStartImport: boolean, totalRows: number, validatedRows: number, importedRows: number, failedRows: number, createdAt: Types.TDateISO, completedAt?: Types.TDateISO | null };

export type ProductionLotImportRowFieldsFragment = { __typename?: 'ProductionLotAsyncImportJobRow', rowIndex: number, status: Types.AsyncImportRowStatus, plan: string, location: string, customer: string, category: string, genus: string, series: string, color: string, weekReady: string, quantity: number, isTrial: boolean, isAd: boolean, isPreFinished?: boolean | null, poNumber: string, sublocation: string, sublocationId?: string | null, error?: string | null, warning?: string | null, createdEntityId?: string | null };

export type GetAsyncImportJobQueryVariables = Types.Exact<{
  asyncImportJobId: Types.Scalars['String']['input'];
}>;


export type GetAsyncImportJobQuery = { __typename?: 'Query', asyncImportJob?: { __typename?: 'AsyncImportJobDocument', asyncImportJobId: string, jobType: Types.AsyncImportJobType, status: Types.AsyncImportJobStatus, autoStartImport: boolean, totalRows: number, validatedRows: number, importedRows: number, failedRows: number, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, completedAt?: Types.TDateISO | null } | null };

export type GetProductionLotAsyncImportJobNewPlansQueryVariables = Types.Exact<{
  asyncImportJobId: Types.Scalars['String']['input'];
}>;


export type GetProductionLotAsyncImportJobNewPlansQuery = { __typename?: 'Query', productionLotAsyncImportJobNewPlans: Array<string> };

export type GetActiveImportJobsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.AsyncImportJobDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.AsyncImportJobDocumentSortInput> | Types.AsyncImportJobDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetActiveImportJobsQuery = { __typename?: 'Query', activeImportJobs?: { __typename?: 'ActiveImportJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'AsyncImportJobDocument', asyncImportJobId: string, jobType: Types.AsyncImportJobType, status: Types.AsyncImportJobStatus, autoStartImport: boolean, totalRows: number, validatedRows: number, importedRows: number, failedRows: number, createdAt: Types.TDateISO, completedAt?: Types.TDateISO | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionLotAsyncImportJobRowsQueryVariables = Types.Exact<{
  asyncImportJobId: Types.Scalars['String']['input'];
  where?: Types.InputMaybe<Types.ProductionLotAsyncImportJobRowFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionLotAsyncImportJobRowSortInput> | Types.ProductionLotAsyncImportJobRowSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionLotAsyncImportJobRowsQuery = { __typename?: 'Query', productionLotAsyncImportJobRows?: { __typename?: 'ProductionLotAsyncImportJobRowsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionLotAsyncImportJobRow', rowIndex: number, status: Types.AsyncImportRowStatus, plan: string, location: string, customer: string, category: string, genus: string, series: string, color: string, weekReady: string, quantity: number, isTrial: boolean, isAd: boolean, isPreFinished?: boolean | null, poNumber: string, sublocation: string, sublocationId?: string | null, error?: string | null, warning?: string | null, createdEntityId?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const AsyncImportJobDetailsFragmentDoc = new TypedDocumentString(`
    fragment AsyncImportJobDetails on AsyncImportJobDocument {
  asyncImportJobId
  jobType
  status
  autoStartImport
  totalRows
  validatedRows
  importedRows
  failedRows
  createdAt
  createdBy
  updatedAt
  completedAt
}
    `, {"fragmentName":"AsyncImportJobDetails"});
export const AsyncImportJobSummaryFragmentDoc = new TypedDocumentString(`
    fragment AsyncImportJobSummary on AsyncImportJobDocument {
  asyncImportJobId
  jobType
  status
  autoStartImport
  totalRows
  validatedRows
  importedRows
  failedRows
  createdAt
  completedAt
}
    `, {"fragmentName":"AsyncImportJobSummary"});
export const ProductionLotImportRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment ProductionLotImportRowFields on ProductionLotAsyncImportJobRow {
  rowIndex
  status
  plan
  location
  customer
  category
  genus
  series
  color
  weekReady
  quantity
  isTrial
  isAd
  isPreFinished
  poNumber
  sublocation
  sublocationId
  error
  warning
  createdEntityId
}
    `, {"fragmentName":"ProductionLotImportRowFields"});
export const GetAsyncImportJobDocument = new TypedDocumentString(`
    query GetAsyncImportJob($asyncImportJobId: String!) {
  asyncImportJob(asyncImportJobId: $asyncImportJobId) {
    ...AsyncImportJobDetails
  }
}
    fragment AsyncImportJobDetails on AsyncImportJobDocument {
  asyncImportJobId
  jobType
  status
  autoStartImport
  totalRows
  validatedRows
  importedRows
  failedRows
  createdAt
  createdBy
  updatedAt
  completedAt
}`);
export const GetProductionLotAsyncImportJobNewPlansDocument = new TypedDocumentString(`
    query GetProductionLotAsyncImportJobNewPlans($asyncImportJobId: String!) {
  productionLotAsyncImportJobNewPlans(asyncImportJobId: $asyncImportJobId)
}
    `);
export const GetActiveImportJobsDocument = new TypedDocumentString(`
    query GetActiveImportJobs($where: AsyncImportJobDocumentFilterInput, $order: [AsyncImportJobDocumentSortInput!], $first: Int, $after: String) {
  activeImportJobs(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...AsyncImportJobSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment AsyncImportJobSummary on AsyncImportJobDocument {
  asyncImportJobId
  jobType
  status
  autoStartImport
  totalRows
  validatedRows
  importedRows
  failedRows
  createdAt
  completedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionLotAsyncImportJobRowsDocument = new TypedDocumentString(`
    query GetProductionLotAsyncImportJobRows($asyncImportJobId: String!, $where: ProductionLotAsyncImportJobRowFilterInput, $order: [ProductionLotAsyncImportJobRowSortInput!], $first: Int, $after: String) {
  productionLotAsyncImportJobRows(
    asyncImportJobId: $asyncImportJobId
    where: $where
    order: $order
    first: $first
    after: $after
  ) {
    nodes {
      ...ProductionLotImportRowFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionLotImportRowFields on ProductionLotAsyncImportJobRow {
  rowIndex
  status
  plan
  location
  customer
  category
  genus
  series
  color
  weekReady
  quantity
  isTrial
  isAd
  isPreFinished
  poNumber
  sublocation
  sublocationId
  error
  warning
  createdEntityId
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetAsyncImportJob: build.query<GetAsyncImportJobQuery, GetAsyncImportJobQueryVariables>({
      query: (variables) => ({ document: GetAsyncImportJobDocument, variables })
    }),
    GetProductionLotAsyncImportJobNewPlans: build.query<GetProductionLotAsyncImportJobNewPlansQuery, GetProductionLotAsyncImportJobNewPlansQueryVariables>({
      query: (variables) => ({ document: GetProductionLotAsyncImportJobNewPlansDocument, variables })
    }),
    GetActiveImportJobs: build.query<GetActiveImportJobsQuery, GetActiveImportJobsQueryVariables | void>({
      query: (variables) => ({ document: GetActiveImportJobsDocument, variables })
    }),
    GetProductionLotAsyncImportJobRows: build.query<GetProductionLotAsyncImportJobRowsQuery, GetProductionLotAsyncImportJobRowsQueryVariables>({
      query: (variables) => ({ document: GetProductionLotAsyncImportJobRowsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetAsyncImportJobQuery, useLazyGetAsyncImportJobQuery, useGetProductionLotAsyncImportJobNewPlansQuery, useLazyGetProductionLotAsyncImportJobNewPlansQuery, useGetActiveImportJobsQuery, useLazyGetActiveImportJobsQuery, useGetProductionLotAsyncImportJobRowsQuery, useLazyGetProductionLotAsyncImportJobRowsQuery } = injectedRtkApi;
